import PropTypes from "prop-types";
import { Link } from "react-router-dom";

export const BreadcrumbItem = ({ url, text }, idx) =>
  text ? (
    url ? (
      <li
        key={idx}
        className={"breadcrumb-item"}
        itemScope
        itemProp={"itemListElement"}
        itemType={"http://schema.org/ListItem"}
      >
        <Link to={url} itemType={"http://schema.org/Thing"} itemProp={"item"}>
          <span itemProp={"name"}>{text}</span>
        </Link>
        <svg
          className="breadcrumb-separator"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 -2 23.628 27.519"
        >
          <polygon
            fill="currentColor"
            points="22.508 13.854 10.457 1.178 11.577 0 23.628 12.676 22.508 13.854"
          />
          <polygon
            fill="currentColor"
            points="7.288 26.341 19.339 13.665 20.459 14.844 8.408 27.519 7.288 26.341"
          />
          <polygon
            fill="currentColor"
            points="15.22 13.854 3.169 1.178 4.289 0 16.34 12.676 15.22 13.854"
          />
          <polygon
            fill="currentColor"
            points="0 26.341 12.051 13.665 13.171 14.844 1.12 27.519 0 26.341"
          />
        </svg>
        <meta itemProp={"position"} content={idx + 1} />
      </li>
    ) : (
      <li key={idx} className={"breadcrumb-item active"}>
        {text}
      </li>
    )
  ) : null;

const Breadcrumbs = ({ items, childComponent = BreadcrumbItem }) => (
  <ol
    role="navigation"
    aria-label="breadcrumbs"
    className={"breadcrumb"}
    itemScope
    itemType={"http://schema.org/BreadcrumbList"}
  >
    {items.map(childComponent)}
  </ol>
);

Breadcrumbs.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      url: PropTypes.string
    })
  ).isRequired
};

export default Breadcrumbs;
